import React from "react";
import { useTheme } from "../ThemeContext";
import DialogWrapper from "./DialogWrapper";
import Button from "./Button";

export default function HowToPlayModal({ closeHowTo }) {
	const darkTheme = useTheme();

	const InfoDivStyle = {
		backgroundColor: darkTheme ? "rgb(31, 41, 55)" : "rgb(225, 240, 255)",
	};

	function showPageTwoOfHowTo() {
		const dialog = document.getElementById("page-1");
		dialog.close();
		dialog.classList.remove("show");
		const pageTwo = document.getElementById("page-2");
		pageTwo.showModal();
		pageTwo.classList.add("show");
	}

	return (
		<div>
			<DialogWrapper id="page-1">
				<p className="font-bold py-8">
					You have 6 chances to guess the 5 letter word, your goal is
					to guess the word in the least amount of tries.
					<br />
					<br />
					You will receive a warning for invalid guesses
				</p>
				<Button
                    color='green'
                    clickFunction={showPageTwoOfHowTo}
                >
                    Next
                </Button>
			</DialogWrapper>
			<DialogWrapper id="page-2">
				<p className="py-4 font-bold">
					Letter backgrounds in game will change color depending on
					their state:
				</p>
				<ul
					style={InfoDivStyle}
					className="flex flex-col gap-6 mt-8 mb-8 shadow-lg border-2
              border-zinc-400 py-6 px-4 rounded-md font-bold"
				>
					<li className="flex gap-2 items-center text-left">
						<div className="h-8 w-8 bg-zinc-500 flex-shrink-0"></div>
						<p>
							Letter is <em>not</em> in the word
						</p>
					</li>
					<li className="flex gap-2 items-center text-left">
						<div className="h-8 w-8 bg-yellow-400 flex-shrink-0"></div>
						<p>
							Letter is in the word,{" "}
							<em>but in the wrong position</em>
						</p>
					</li>
					<li className="flex gap-2 items-center text-left">
						<div className="h-8 w-8 bg-green-600 flex-shrink-0"></div>
						<p>Letter is in the correct position</p>
					</li>
				</ul>
                <Button
                    color='green'
                    clickFunction={closeHowTo}
                >
                    Got it!
                </Button>
			</DialogWrapper>
		</div>
	);
}
